/**
 * Datei-Token aus dem Nachrichtentext lesen.
 *
 * Eine Nachricht kann mehrere Dateien tragen — Bots hängen z. B. zwei
 * Auswertungen an dieselbe Antwort. Früher wurde nur das erste Token
 * erkannt; die übrigen blieben als roher Text in der Nachricht stehen.
 */

export interface FileAttachment {
  fileId: string;
  contentType: string;
  filename: string;
  /** AES-256-GCM key (base64url) — present for client-encrypted files */
  encryptionKey?: string;
  /** AES-256-GCM IV (base64url) — present for client-encrypted files */
  encryptionIv?: string;
}

/** [efile:id:mime:name:key:iv] — client-encrypted */
const EFILE_TOKEN = /\[efile:([a-f0-9-]+):([^:]+):([^:]+):([A-Za-z0-9_-]+):([A-Za-z0-9_-]+)\]/g;
/** [file:id:mime:name] — legacy, unencrypted */
const FILE_TOKEN = /\[file:([a-f0-9-]+):([^:]+):([^\]]+)\]/g;

export function parseFileAttachments(text: string): {
  text: string;
  files: FileAttachment[];
} {
  const found: Array<{ index: number; raw: string; file: FileAttachment }> = [];

  for (const m of text.matchAll(EFILE_TOKEN)) {
    found.push({
      index: m.index!,
      raw: m[0],
      file: {
        fileId: m[1]!,
        contentType: m[2]!,
        filename: m[3]!,
        encryptionKey: m[4]!,
        encryptionIv: m[5]!,
      },
    });
  }
  for (const m of text.matchAll(FILE_TOKEN)) {
    // [efile:…] enthält [file:… nicht als Teilstring — kein Doppelfund möglich.
    found.push({
      index: m.index!,
      raw: m[0],
      file: { fileId: m[1]!, contentType: m[2]!, filename: m[3]! },
    });
  }

  if (found.length === 0) return { text, files: [] };

  found.sort((a, b) => a.index - b.index);

  let clean = text;
  for (const { raw } of found) clean = clean.replace(raw, "");

  return { text: clean.trim(), files: found.map((f) => f.file) };
}
